var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { Button } from '../button';
var CardFooter = /** @class */ (function (_super) {
    __extends(CardFooter, _super);
    function CardFooter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardFooter.prototype.render = function () {
        var _a = this.props, className = _a.className, isButtonBlock = _a.isButtonBlock, onClickCancel = _a.onClickCancel, onClickSave = _a.onClickSave;
        return (React.createElement("div", { className: 'gr-card-footer ' + (className || '') },
            this.props.children,
            isButtonBlock && (React.createElement("div", { className: 'footer-button' },
                React.createElement(Button, { color: 'primary', size: 'sm', outline: true, className: 'mr-x4', onClick: onClickCancel }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
                React.createElement(Button, { color: 'primary', size: 'sm', onClick: onClickSave }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
    };
    return CardFooter;
}(Component));
export default CardFooter;
//# sourceMappingURL=CardFooter.js.map